export const hasDialogSupport = typeof window !== 'undefined' && 'HTMLDialogElement' in window;
